{
  "ianaAproximateByOffset": [
    { "offset": -60, "iana": "Atlantic/Azores", "description": "Azores Standard Time", "dst": false },
    { "offset": 0, "iana": "Atlantic/Azores", "description": "Azores Daylight Time", "dst": true },
    { "offset": -120, "iana": "America/Noronha", "description": "Fernando de Noronha", "dst": false },
    { "offset": -180, "iana": "America/Argentina/Buenos_Aires", "description": "Argentina Standard Time", "dst": false },
    { "offset": -180, "iana": "America/Sao_Paulo", "description": "Brazil Daylight Time (was, now mostly abolished)", "dst": true },
    { "offset": -240, "iana": "America/Halifax", "description": "Atlantic Standard Time", "dst": false },
    { "offset": -180, "iana": "America/Halifax", "description": "Atlantic Daylight Time", "dst": true },
    { "offset": -300, "iana": "America/New_York", "description": "Eastern Standard Time", "dst": false },
    { "offset": -240, "iana": "America/New_York", "description": "Eastern Daylight Time", "dst": true },
    { "offset": -360, "iana": "America/Chicago", "description": "Central Standard Time", "dst": false },
    { "offset": -300, "iana": "America/Chicago", "description": "Central Daylight Time", "dst": true },
    { "offset": -420, "iana": "America/Denver", "description": "Mountain Standard Time", "dst": false },
    { "offset": -360, "iana": "America/Denver", "description": "Mountain Daylight Time", "dst": true },
    { "offset": -480, "iana": "America/Los_Angeles", "description": "Pacific Standard Time", "dst": false },
    { "offset": -420, "iana": "America/Los_Angeles", "description": "Pacific Daylight Time", "dst": true },
    { "offset": -480, "iana": "America/Anchorage", "description": "Alaska Daylight Time", "dst": true },
    { "offset": -540, "iana": "America/Anchorage", "description": "Alaska Standard Time", "dst": false },
    { "offset": -600, "iana": "Pacific/Honolulu", "description": "Hawaii-Aleutian Standard Time", "dst": false }
  ],
  "ianaTimezones": [
    {
      "value": "Atlantic/Azores",
      "label": "(UTC-01:00) Azores",
      "id": "Azores Standard Time"
    },
    {
      "value": "America/Scoresbysund",
      "label": "(UTC-01:00) Azores",
      "id": "Azores Standard Time"
    },
    {
      "value": "Atlantic/Cape_Verde",
      "label": "(UTC-01:00) Cabo Verde Is.",
      "id": "Cape Verde Standard Time"
    },
    {
      "value": "Etc/GMT+1",
      "label": "(UTC-01:00) Cabo Verde Is.",
      "id": "Cape Verde Standard Time"
    },
    {
      "value": "Etc/GMT+2",
      "label": "(UTC-02:00) Coordinated Universal Time-02",
      "id": "UTC-02"
    },
    {
      "value": "America/Noronha",
      "label": "(UTC-02:00) Coordinated Universal Time-02",
      "id": "UTC-02"
    },
    {
      "value": "Atlantic/South_Georgia",
      "label": "(UTC-02:00) Coordinated Universal Time-02",
      "id": "UTC-02"
    },
    {
      "value": "Brazil/DeNoronha",
      "label": "(UTC-02:00) Coordinated Universal Time-02",
      "id": "UTC-02"
    },
    {
      "value": "America/Godthab",
      "label": "(UTC-02:00) Greenland",
      "id": "Greenland Standard Time"
    },
    {
      "value": "America/Nuuk",
      "label": "(UTC-02:00) Greenland",
      "id": "Greenland Standard Time"
    },
    {
      "value": "America/Araguaina",
      "label": "(UTC-03:00) Araguaina",
      "id": "Tocantins Standard Time"
    },
    {
      "value": "America/Asuncion",
      "label": "(UTC-03:00) Asuncion",
      "id": "Paraguay Standard Time"
    },
    {
      "value": "America/Sao_Paulo",
      "label": "(UTC-03:00) Brasilia",
      "id": "E. South America Standard Time"
    },
    {
      "value": "Brazil/East",
      "label": "(UTC-03:00) Brasilia",
      "id": "E. South America Standard Time"
    },
    {
      "value": "America/Cayenne",
      "label": "(UTC-03:00) Cayenne, Fortaleza",
      "id": "SA Eastern Standard Time"
    },
    {
      "value": "Antarctica/Rothera",
      "label": "(UTC-03:00) Cayenne, Fortaleza",
      "id": "SA Eastern Standard Time"
    },
    {
      "value": "Antarctica/Palmer",
      "label": "(UTC-03:00) Cayenne, Fortaleza",
      "id": "SA Eastern Standard Time"
    },
    {
      "value": "America/Fortaleza",
      "label": "(UTC-03:00) Cayenne, Fortaleza",
      "id": "SA Eastern Standard Time"
    },
    {
      "value": "America/Belem",
      "label": "(UTC-03:00) Cayenne, Fortaleza",
      "id": "SA Eastern Standard Time"
    },
    {
      "value": "America/Maceio",
      "label": "(UTC-03:00) Cayenne, Fortaleza",
      "id": "SA Eastern Standard Time"
    },
    {
      "value": "America/Recife",
      "label": "(UTC-03:00) Cayenne, Fortaleza",
      "id": "SA Eastern Standard Time"
    },
    {
      "value": "America/Santarem",
      "label": "(UTC-03:00) Cayenne, Fortaleza",
      "id": "SA Eastern Standard Time"
    },
    {
      "value": "Atlantic/Stanley",
      "label": "(UTC-03:00) Cayenne, Fortaleza",
      "id": "SA Eastern Standard Time"
    },
    {
      "value": "America/Paramaribo",
      "label": "(UTC-03:00) Cayenne, Fortaleza",
      "id": "SA Eastern Standard Time"
    },
    {
      "value": "Etc/GMT+3",
      "label": "(UTC-03:00) Cayenne, Fortaleza",
      "id": "SA Eastern Standard Time"
    },
    {
      "value": "America/Buenos_Aires",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Argentina/La_Rioja",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Argentina/Rio_Gallegos",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Argentina/Salta",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Argentina/San_Juan",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Argentina/San_Luis",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Argentina/Tucuman",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Argentina/Ushuaia",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Catamarca",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Cordoba",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Jujuy",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Mendoza",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Argentina/Buenos_Aires",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Argentina/Catamarca",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Argentina/ComodRivadavia",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Argentina/Cordoba",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Rosario",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Argentina/Jujuy",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Argentina/Mendoza",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Montevideo",
      "label": "(UTC-03:00) Montevideo",
      "id": "Montevideo Standard Time"
    },
    {
      "value": "America/Punta_Arenas",
      "label": "(UTC-03:00) Punta Arenas",
      "id": "Magallanes Standard Time"
    },
    {
      "value": "America/Miquelon",
      "label": "(UTC-03:00) Saint Pierre and Miquelon",
      "id": "Saint Pierre Standard Time"
    },
    {
      "value": "America/Bahia",
      "label": "(UTC-03:00) Salvador",
      "id": "Bahia Standard Time"
    },
    {
      "value": "America/St_Johns",
      "label": "(UTC-03:30) Newfoundland",
      "id": "Newfoundland Standard Time"
    },
    {
      "value": "Canada/Newfoundland",
      "label": "(UTC-03:30) Newfoundland",
      "id": "Newfoundland Standard Time"
    },
    {
      "value": "America/Halifax",
      "label": "(UTC-04:00) Atlantic Time (Canada)",
      "id": "Atlantic Standard Time"
    },
    {
      "value": "Atlantic/Bermuda",
      "label": "(UTC-04:00) Atlantic Time (Canada)",
      "id": "Atlantic Standard Time"
    },
    {
      "value": "America/Glace_Bay",
      "label": "(UTC-04:00) Atlantic Time (Canada)",
      "id": "Atlantic Standard Time"
    },
    {
      "value": "America/Goose_Bay",
      "label": "(UTC-04:00) Atlantic Time (Canada)",
      "id": "Atlantic Standard Time"
    },
    {
      "value": "America/Moncton",
      "label": "(UTC-04:00) Atlantic Time (Canada)",
      "id": "Atlantic Standard Time"
    },
    {
      "value": "America/Thule",
      "label": "(UTC-04:00) Atlantic Time (Canada)",
      "id": "Atlantic Standard Time"
    },
    {
      "value": "Canada/Atlantic",
      "label": "(UTC-04:00) Atlantic Time (Canada)",
      "id": "Atlantic Standard Time"
    },
    {
      "value": "America/Caracas",
      "label": "(UTC-04:00) Caracas",
      "id": "Venezuela Standard Time"
    },
    {
      "value": "America/Cuiaba",
      "label": "(UTC-04:00) Cuiaba",
      "id": "Central Brazilian Standard Time"
    },
    {
      "value": "America/Campo_Grande",
      "label": "(UTC-04:00) Cuiaba",
      "id": "Central Brazilian Standard Time"
    },
    {
      "value": "America/La_Paz",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Antigua",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Anguilla",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Aruba",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Barbados",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/St_Barthelemy",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Kralendijk",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Manaus",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Boa_Vista",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Porto_Velho",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Blanc-Sablon",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Curacao",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Dominica",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Santo_Domingo",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Grenada",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Guadeloupe",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Guyana",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/St_Kitts",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/St_Lucia",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Marigot",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Martinique",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Montserrat",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Puerto_Rico",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Lower_Princes",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Port_of_Spain",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/St_Vincent",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Tortola",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/St_Thomas",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "Etc/GMT+4",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "Brazil/West",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Virgin",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Santiago",
      "label": "(UTC-04:00) Santiago",
      "id": "Pacific SA Standard Time"
    },
    {
      "value": "Chile/Continental",
      "label": "(UTC-04:00) Santiago",
      "id": "Pacific SA Standard Time"
    },
    {
      "value": "America/Bogota",
      "label": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
      "id": "SA Pacific Standard Time"
    },
    {
      "value": "America/Rio_Branco",
      "label": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
      "id": "SA Pacific Standard Time"
    },
    {
      "value": "America/Eirunepe",
      "label": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
      "id": "SA Pacific Standard Time"
    },
    {
      "value": "America/Coral_Harbour",
      "label": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
      "id": "SA Pacific Standard Time"
    },
    {
      "value": "America/Guayaquil",
      "label": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
      "id": "SA Pacific Standard Time"
    },
    {
      "value": "America/Jamaica",
      "label": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
      "id": "SA Pacific Standard Time"
    },
    {
      "value": "America/Cayman",
      "label": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
      "id": "SA Pacific Standard Time"
    },
    {
      "value": "America/Panama",
      "label": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
      "id": "SA Pacific Standard Time"
    },
    {
      "value": "America/Lima",
      "label": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
      "id": "SA Pacific Standard Time"
    },
    {
      "value": "Etc/GMT+5",
      "label": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
      "id": "SA Pacific Standard Time"
    },
    {
      "value": "Jamaica",
      "label": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
      "id": "SA Pacific Standard Time"
    },
    {
      "value": "America/Atikokan",
      "label": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
      "id": "SA Pacific Standard Time"
    },
    {
      "value": "EST",
      "label": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
      "id": "SA Pacific Standard Time"
    },
    {
      "value": "America/Porto_Acre",
      "label": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
      "id": "SA Pacific Standard Time"
    },
    {
      "value": "Brazil/Acre",
      "label": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
      "id": "SA Pacific Standard Time"
    },
    {
      "value": "America/Cancun",
      "label": "(UTC-05:00) Chetumal",
      "id": "Eastern Standard Time (Mexico)"
    },
    {
      "value": "America/New_York",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "America/Nassau",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "America/Toronto",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "America/Iqaluit",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "America/Detroit",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "America/Indiana/Petersburg",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "America/Indiana/Vincennes",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "America/Indiana/Winamac",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "America/Kentucky/Monticello",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "America/Louisville",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "US/Michigan",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "America/Pangnirtung",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "America/Kentucky/Louisville",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "US/Eastern",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "EST5EDT",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "America/Montreal",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "Canada/Eastern",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "America/Nipigon",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "America/Thunder_Bay",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "America/Port-au-Prince",
      "label": "(UTC-05:00) Haiti",
      "id": "Haiti Standard Time"
    },
    {
      "value": "America/Havana",
      "label": "(UTC-05:00) Havana",
      "id": "Cuba Standard Time"
    },
    {
      "value": "Cuba",
      "label": "(UTC-05:00) Havana",
      "id": "Cuba Standard Time"
    },
    {
      "value": "America/Indianapolis",
      "label": "(UTC-05:00) Indiana (East)",
      "id": "US Eastern Standard Time"
    },
    {
      "value": "America/Indiana/Marengo",
      "label": "(UTC-05:00) Indiana (East)",
      "id": "US Eastern Standard Time"
    },
    {
      "value": "America/Indiana/Vevay",
      "label": "(UTC-05:00) Indiana (East)",
      "id": "US Eastern Standard Time"
    },
    {
      "value": "America/Indiana/Indianapolis",
      "label": "(UTC-05:00) Indiana (East)",
      "id": "US Eastern Standard Time"
    },
    {
      "value": "US/East-Indiana",
      "label": "(UTC-05:00) Indiana (East)",
      "id": "US Eastern Standard Time"
    },
    {
      "value": "America/Fort_Wayne",
      "label": "(UTC-05:00) Indiana (East)",
      "id": "US Eastern Standard Time"
    },
    {
      "value": "America/Grand_Turk",
      "label": "(UTC-05:00) Turks and Caicos",
      "id": "Turks And Caicos Standard Time"
    },
    {
      "value": "America/Guatemala",
      "label": "(UTC-06:00) Central America",
      "id": "Central America Standard Time"
    },
    {
      "value": "America/Belize",
      "label": "(UTC-06:00) Central America",
      "id": "Central America Standard Time"
    },
    {
      "value": "America/Costa_Rica",
      "label": "(UTC-06:00) Central America",
      "id": "Central America Standard Time"
    },
    {
      "value": "Pacific/Galapagos",
      "label": "(UTC-06:00) Central America",
      "id": "Central America Standard Time"
    },
    {
      "value": "America/Tegucigalpa",
      "label": "(UTC-06:00) Central America",
      "id": "Central America Standard Time"
    },
    {
      "value": "America/Managua",
      "label": "(UTC-06:00) Central America",
      "id": "Central America Standard Time"
    },
    {
      "value": "America/El_Salvador",
      "label": "(UTC-06:00) Central America",
      "id": "Central America Standard Time"
    },
    {
      "value": "Etc/GMT+6",
      "label": "(UTC-06:00) Central America",
      "id": "Central America Standard Time"
    },
    {
      "value": "America/Chicago",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "America/Winnipeg",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "America/Rankin_Inlet",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "America/Resolute",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "America/Matamoros",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "America/Ojinaga",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "America/Indiana/Knox",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "America/Indiana/Tell_City",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "America/Menominee",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "America/North_Dakota/Beulah",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "America/North_Dakota/Center",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "America/North_Dakota/New_Salem",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "US/Central",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "CST6CDT",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "America/Knox_IN",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "US/Indiana-Starke",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "Canada/Central",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "America/Rainy_River",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "Pacific/Easter",
      "label": "(UTC-06:00) Easter Island",
      "id": "Easter Island Standard Time"
    },
    {
      "value": "Chile/EasterIsland",
      "label": "(UTC-06:00) Easter Island",
      "id": "Easter Island Standard Time"
    },
    {
      "value": "America/Mexico_City",
      "label": "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
      "id": "Central Standard Time (Mexico)"
    },
    {
      "value": "America/Bahia_Banderas",
      "label": "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
      "id": "Central Standard Time (Mexico)"
    },
    {
      "value": "America/Merida",
      "label": "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
      "id": "Central Standard Time (Mexico)"
    },
    {
      "value": "America/Monterrey",
      "label": "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
      "id": "Central Standard Time (Mexico)"
    },
    {
      "value": "America/Chihuahua",
      "label": "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
      "id": "Central Standard Time (Mexico)"
    },
    {
      "value": "Mexico/General",
      "label": "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
      "id": "Central Standard Time (Mexico)"
    },
    {
      "value": "America/Regina",
      "label": "(UTC-06:00) Saskatchewan",
      "id": "Canada Central Standard Time"
    },
    {
      "value": "America/Swift_Current",
      "label": "(UTC-06:00) Saskatchewan",
      "id": "Canada Central Standard Time"
    },
    {
      "value": "Canada/Saskatchewan",
      "label": "(UTC-06:00) Saskatchewan",
      "id": "Canada Central Standard Time"
    },
    {
      "value": "America/Phoenix",
      "label": "(UTC-07:00) Arizona",
      "id": "US Mountain Standard Time"
    },
    {
      "value": "America/Creston",
      "label": "(UTC-07:00) Arizona",
      "id": "US Mountain Standard Time"
    },
    {
      "value": "America/Dawson_Creek",
      "label": "(UTC-07:00) Arizona",
      "id": "US Mountain Standard Time"
    },
    {
      "value": "America/Fort_Nelson",
      "label": "(UTC-07:00) Arizona",
      "id": "US Mountain Standard Time"
    },
    {
      "value": "America/Hermosillo",
      "label": "(UTC-07:00) Arizona",
      "id": "US Mountain Standard Time"
    },
    {
      "value": "Etc/GMT+7",
      "label": "(UTC-07:00) Arizona",
      "id": "US Mountain Standard Time"
    },
    {
      "value": "US/Arizona",
      "label": "(UTC-07:00) Arizona",
      "id": "US Mountain Standard Time"
    },
    {
      "value": "MST",
      "label": "(UTC-07:00) Arizona",
      "id": "US Mountain Standard Time"
    },
    {
      "value": "America/Mazatlan",
      "label": "(UTC-07:00) La Paz, Mazatlan",
      "id": "Mountain Standard Time (Mexico)"
    },
    {
      "value": "Mexico/BajaSur",
      "label": "(UTC-07:00) La Paz, Mazatlan",
      "id": "Mountain Standard Time (Mexico)"
    },
    {
      "value": "America/Denver",
      "label": "(UTC-07:00) Mountain Time (US & Canada)",
      "id": "Mountain Standard Time"
    },
    {
      "value": "America/Edmonton",
      "label": "(UTC-07:00) Mountain Time (US & Canada)",
      "id": "Mountain Standard Time"
    },
    {
      "value": "America/Cambridge_Bay",
      "label": "(UTC-07:00) Mountain Time (US & Canada)",
      "id": "Mountain Standard Time"
    },
    {
      "value": "America/Inuvik",
      "label": "(UTC-07:00) Mountain Time (US & Canada)",
      "id": "Mountain Standard Time"
    },
    {
      "value": "America/Ciudad_Juarez",
      "label": "(UTC-07:00) Mountain Time (US & Canada)",
      "id": "Mountain Standard Time"
    },
    {
      "value": "America/Boise",
      "label": "(UTC-07:00) Mountain Time (US & Canada)",
      "id": "Mountain Standard Time"
    },
    {
      "value": "America/Shiprock",
      "label": "(UTC-07:00) Mountain Time (US & Canada)",
      "id": "Mountain Standard Time"
    },
    {
      "value": "Navajo",
      "label": "(UTC-07:00) Mountain Time (US & Canada)",
      "id": "Mountain Standard Time"
    },
    {
      "value": "US/Mountain",
      "label": "(UTC-07:00) Mountain Time (US & Canada)",
      "id": "Mountain Standard Time"
    },
    {
      "value": "MST7MDT",
      "label": "(UTC-07:00) Mountain Time (US & Canada)",
      "id": "Mountain Standard Time"
    },
    {
      "value": "Canada/Mountain",
      "label": "(UTC-07:00) Mountain Time (US & Canada)",
      "id": "Mountain Standard Time"
    },
    {
      "value": "America/Yellowknife",
      "label": "(UTC-07:00) Mountain Time (US & Canada)",
      "id": "Mountain Standard Time"
    },
    {
      "value": "America/Whitehorse",
      "label": "(UTC-07:00) Yukon",
      "id": "Yukon Standard Time"
    },
    {
      "value": "America/Dawson",
      "label": "(UTC-07:00) Yukon",
      "id": "Yukon Standard Time"
    },
    {
      "value": "Canada/Yukon",
      "label": "(UTC-07:00) Yukon",
      "id": "Yukon Standard Time"
    },
    {
      "value": "America/Tijuana",
      "label": "(UTC-08:00) Baja California",
      "id": "Pacific Standard Time (Mexico)"
    },
    {
      "value": "America/Ensenada",
      "label": "(UTC-08:00) Baja California",
      "id": "Pacific Standard Time (Mexico)"
    },
    {
      "value": "Mexico/BajaNorte",
      "label": "(UTC-08:00) Baja California",
      "id": "Pacific Standard Time (Mexico)"
    },
    {
      "value": "America/Santa_Isabel",
      "label": "(UTC-08:00) Baja California",
      "id": "Pacific Standard Time (Mexico)"
    },
    {
      "value": "Etc/GMT+8",
      "label": "(UTC-08:00) Coordinated Universal Time-08",
      "id": "UTC-08"
    },
    {
      "value": "Pacific/Pitcairn",
      "label": "(UTC-08:00) Coordinated Universal Time-08",
      "id": "UTC-08"
    },
    {
      "value": "America/Los_Angeles",
      "label": "(UTC-08:00) Pacific Time (US & Canada)",
      "id": "Pacific Standard Time"
    },
    {
      "value": "America/Vancouver",
      "label": "(UTC-08:00) Pacific Time (US & Canada)",
      "id": "Pacific Standard Time"
    },
    {
      "value": "US/Pacific",
      "label": "(UTC-08:00) Pacific Time (US & Canada)",
      "id": "Pacific Standard Time"
    },
    {
      "value": "PST8PDT",
      "label": "(UTC-08:00) Pacific Time (US & Canada)",
      "id": "Pacific Standard Time"
    },
    {
      "value": "Canada/Pacific",
      "label": "(UTC-08:00) Pacific Time (US & Canada)",
      "id": "Pacific Standard Time"
    },
    {
      "value": "America/Anchorage",
      "label": "(UTC-09:00) Alaska",
      "id": "Alaskan Standard Time"
    },
    {
      "value": "America/Juneau",
      "label": "(UTC-09:00) Alaska",
      "id": "Alaskan Standard Time"
    },
    {
      "value": "America/Metlakatla",
      "label": "(UTC-09:00) Alaska",
      "id": "Alaskan Standard Time"
    },
    {
      "value": "America/Nome",
      "label": "(UTC-09:00) Alaska",
      "id": "Alaskan Standard Time"
    },
    {
      "value": "America/Sitka",
      "label": "(UTC-09:00) Alaska",
      "id": "Alaskan Standard Time"
    },
    {
      "value": "America/Yakutat",
      "label": "(UTC-09:00) Alaska",
      "id": "Alaskan Standard Time"
    },
    {
      "value": "US/Alaska",
      "label": "(UTC-09:00) Alaska",
      "id": "Alaskan Standard Time"
    },
    {
      "value": "Etc/GMT+9",
      "label": "(UTC-09:00) Coordinated Universal Time-09",
      "id": "UTC-09"
    },
    {
      "value": "Pacific/Gambier",
      "label": "(UTC-09:00) Coordinated Universal Time-09",
      "id": "UTC-09"
    },
    {
      "value": "Pacific/Marquesas",
      "label": "(UTC-09:30) Marquesas Islands",
      "id": "Marquesas Standard Time"
    },
    {
      "value": "America/Adak",
      "label": "(UTC-10:00) Aleutian Islands",
      "id": "Aleutian Standard Time"
    },
    {
      "value": "America/Atka",
      "label": "(UTC-10:00) Aleutian Islands",
      "id": "Aleutian Standard Time"
    },
    {
      "value": "US/Aleutian",
      "label": "(UTC-10:00) Aleutian Islands",
      "id": "Aleutian Standard Time"
    },
    {
      "value": "Pacific/Honolulu",
      "label": "(UTC-10:00) Hawaii",
      "id": "Hawaiian Standard Time"
    },
    {
      "value": "Pacific/Rarotonga",
      "label": "(UTC-10:00) Hawaii",
      "id": "Hawaiian Standard Time"
    },
    {
      "value": "Pacific/Tahiti",
      "label": "(UTC-10:00) Hawaii",
      "id": "Hawaiian Standard Time"
    },
    {
      "value": "Etc/GMT+10",
      "label": "(UTC-10:00) Hawaii",
      "id": "Hawaiian Standard Time"
    },
    {
      "value": "US/Hawaii",
      "label": "(UTC-10:00) Hawaii",
      "id": "Hawaiian Standard Time"
    },
    {
      "value": "Pacific/Johnston",
      "label": "(UTC-10:00) Hawaii",
      "id": "Hawaiian Standard Time"
    },
    {
      "value": "HST",
      "label": "(UTC-10:00) Hawaii",
      "id": "Hawaiian Standard Time"
    },
    {
      "value": "Etc/GMT+11",
      "label": "(UTC-11:00) Coordinated Universal Time-11",
      "id": "UTC-11"
    },
    {
      "value": "Pacific/Pago_Pago",
      "label": "(UTC-11:00) Coordinated Universal Time-11",
      "id": "UTC-11"
    },
    {
      "value": "Pacific/Niue",
      "label": "(UTC-11:00) Coordinated Universal Time-11",
      "id": "UTC-11"
    },
    {
      "value": "Pacific/Midway",
      "label": "(UTC-11:00) Coordinated Universal Time-11",
      "id": "UTC-11"
    },
    {
      "value": "Pacific/Samoa",
      "label": "(UTC-11:00) Coordinated Universal Time-11",
      "id": "UTC-11"
    },
    {
      "value": "US/Samoa",
      "label": "(UTC-11:00) Coordinated Universal Time-11",
      "id": "UTC-11"
    },
    {
      "value": "Etc/GMT+12",
      "label": "(UTC-12:00) International Date Line West",
      "id": "Dateline Standard Time"
    },
    {
      "value": "Etc/UTC",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "Etc/GMT",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "Etc/GMT+0",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "Etc/GMT-0",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "Etc/GMT0",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "Etc/Greenwich",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "GMT",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "GMT+0",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "GMT-0",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "GMT0",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "Greenwich",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "Etc/UCT",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "Etc/Universal",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "Etc/Zulu",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "UCT",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "UTC",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "Universal",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "Zulu",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "Europe/London",
      "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
      "id": "GMT Standard Time"
    },
    {
      "value": "Atlantic/Canary",
      "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
      "id": "GMT Standard Time"
    },
    {
      "value": "Atlantic/Faeroe",
      "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
      "id": "GMT Standard Time"
    },
    {
      "value": "Europe/Guernsey",
      "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
      "id": "GMT Standard Time"
    },
    {
      "value": "Europe/Dublin",
      "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
      "id": "GMT Standard Time"
    },
    {
      "value": "Europe/Isle_of_Man",
      "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
      "id": "GMT Standard Time"
    },
    {
      "value": "Europe/Jersey",
      "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
      "id": "GMT Standard Time"
    },
    {
      "value": "Europe/Lisbon",
      "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
      "id": "GMT Standard Time"
    },
    {
      "value": "Atlantic/Madeira",
      "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
      "id": "GMT Standard Time"
    },
    {
      "value": "Atlantic/Faroe",
      "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
      "id": "GMT Standard Time"
    },
    {
      "value": "Eire",
      "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
      "id": "GMT Standard Time"
    },
    {
      "value": "Portugal",
      "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
      "id": "GMT Standard Time"
    },
    {
      "value": "WET",
      "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
      "id": "GMT Standard Time"
    },
    {
      "value": "Europe/Belfast",
      "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
      "id": "GMT Standard Time"
    },
    {
      "value": "GB",
      "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
      "id": "GMT Standard Time"
    },
    {
      "value": "GB-Eire",
      "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
      "id": "GMT Standard Time"
    },
    {
      "value": "Atlantic/Reykjavik",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "Atlantic/St_Helena",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "Africa/Ouagadougou",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "Africa/Abidjan",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "Africa/Accra",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "America/Danmarkshavn",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "Africa/Banjul",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "Africa/Conakry",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "Africa/Bissau",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "Africa/Monrovia",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "Africa/Bamako",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "Africa/Nouakchott",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "Africa/Freetown",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "Africa/Dakar",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "Africa/Lome",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "Iceland",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "Africa/Timbuktu",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "Africa/Sao_Tome",
      "label": "(UTC+00:00) Sao Tome",
      "id": "Sao Tome Standard Time"
    },
    {
      "value": "Europe/Berlin",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Europe/Andorra",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Europe/Vienna",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Europe/Zurich",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Europe/Busingen",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Europe/Gibraltar",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Europe/Rome",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Europe/Vaduz",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Europe/Luxembourg",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Europe/Monaco",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Europe/Malta",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Europe/Amsterdam",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Europe/Oslo",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Europe/Stockholm",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Arctic/Longyearbyen",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Europe/San_Marino",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Europe/Vatican",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Atlantic/Jan_Mayen",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Europe/Budapest",
      "label": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
      "id": "Central Europe Standard Time"
    },
    {
      "value": "Europe/Tirane",
      "label": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
      "id": "Central Europe Standard Time"
    },
    {
      "value": "Europe/Prague",
      "label": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
      "id": "Central Europe Standard Time"
    },
    {
      "value": "Europe/Podgorica",
      "label": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
      "id": "Central Europe Standard Time"
    },
    {
      "value": "Europe/Belgrade",
      "label": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
      "id": "Central Europe Standard Time"
    },
    {
      "value": "Europe/Ljubljana",
      "label": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
      "id": "Central Europe Standard Time"
    },
    {
      "value": "Europe/Bratislava",
      "label": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
      "id": "Central Europe Standard Time"
    },
    {
      "value": "Europe/Paris",
      "label": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
      "id": "Romance Standard Time"
    },
    {
      "value": "Europe/Brussels",
      "label": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
      "id": "Romance Standard Time"
    },
    {
      "value": "Europe/Copenhagen",
      "label": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
      "id": "Romance Standard Time"
    },
    {
      "value": "Africa/Ceuta",
      "label": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
      "id": "Romance Standard Time"
    },
    {
      "value": "Europe/Madrid",
      "label": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
      "id": "Romance Standard Time"
    },
    {
      "value": "CET",
      "label": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
      "id": "Romance Standard Time"
    },
    {
      "value": "MET",
      "label": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
      "id": "Romance Standard Time"
    },
    {
      "value": "Africa/Casablanca",
      "label": "(UTC+01:00) Casablanca",
      "id": "Morocco Standard Time"
    },
    {
      "value": "Africa/El_Aaiun",
      "label": "(UTC+01:00) Casablanca",
      "id": "Morocco Standard Time"
    },
    {
      "value": "Europe/Warsaw",
      "label": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
      "id": "Central European Standard Time"
    },
    {
      "value": "Europe/Sarajevo",
      "label": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
      "id": "Central European Standard Time"
    },
    {
      "value": "Europe/Zagreb",
      "label": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
      "id": "Central European Standard Time"
    },
    {
      "value": "Europe/Skopje",
      "label": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
      "id": "Central European Standard Time"
    },
    {
      "value": "Poland",
      "label": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
      "id": "Central European Standard Time"
    },
    {
      "value": "Africa/Lagos",
      "label": "(UTC+01:00) West Central Africa",
      "id": "W. Central Africa Standard Time"
    },
    {
      "value": "Africa/Luanda",
      "label": "(UTC+01:00) West Central Africa",
      "id": "W. Central Africa Standard Time"
    },
    {
      "value": "Africa/Porto-Novo",
      "label": "(UTC+01:00) West Central Africa",
      "id": "W. Central Africa Standard Time"
    },
    {
      "value": "Africa/Kinshasa",
      "label": "(UTC+01:00) West Central Africa",
      "id": "W. Central Africa Standard Time"
    },
    {
      "value": "Africa/Bangui",
      "label": "(UTC+01:00) West Central Africa",
      "id": "W. Central Africa Standard Time"
    },
    {
      "value": "Africa/Brazzaville",
      "label": "(UTC+01:00) West Central Africa",
      "id": "W. Central Africa Standard Time"
    },
    {
      "value": "Africa/Douala",
      "label": "(UTC+01:00) West Central Africa",
      "id": "W. Central Africa Standard Time"
    },
    {
      "value": "Africa/Algiers",
      "label": "(UTC+01:00) West Central Africa",
      "id": "W. Central Africa Standard Time"
    },
    {
      "value": "Africa/Libreville",
      "label": "(UTC+01:00) West Central Africa",
      "id": "W. Central Africa Standard Time"
    },
    {
      "value": "Africa/Malabo",
      "label": "(UTC+01:00) West Central Africa",
      "id": "W. Central Africa Standard Time"
    },
    {
      "value": "Africa/Niamey",
      "label": "(UTC+01:00) West Central Africa",
      "id": "W. Central Africa Standard Time"
    },
    {
      "value": "Africa/Ndjamena",
      "label": "(UTC+01:00) West Central Africa",
      "id": "W. Central Africa Standard Time"
    },
    {
      "value": "Africa/Tunis",
      "label": "(UTC+01:00) West Central Africa",
      "id": "W. Central Africa Standard Time"
    },
    {
      "value": "Etc/GMT-1",
      "label": "(UTC+01:00) West Central Africa",
      "id": "W. Central Africa Standard Time"
    },
    {
      "value": "Europe/Bucharest",
      "label": "(UTC+02:00) Athens, Bucharest",
      "id": "GTB Standard Time"
    },
    {
      "value": "Asia/Nicosia",
      "label": "(UTC+02:00) Athens, Bucharest",
      "id": "GTB Standard Time"
    },
    {
      "value": "Asia/Famagusta",
      "label": "(UTC+02:00) Athens, Bucharest",
      "id": "GTB Standard Time"
    },
    {
      "value": "Europe/Athens",
      "label": "(UTC+02:00) Athens, Bucharest",
      "id": "GTB Standard Time"
    },
    {
      "value": "Europe/Nicosia",
      "label": "(UTC+02:00) Athens, Bucharest",
      "id": "GTB Standard Time"
    },
    {
      "value": "EET",
      "label": "(UTC+02:00) Athens, Bucharest",
      "id": "GTB Standard Time"
    },
    {
      "value": "Asia/Beirut",
      "label": "(UTC+02:00) Beirut",
      "id": "Middle East Standard Time"
    },
    {
      "value": "Africa/Cairo",
      "label": "(UTC+02:00) Cairo",
      "id": "Egypt Standard Time"
    },
    {
      "value": "Egypt",
      "label": "(UTC+02:00) Cairo",
      "id": "Egypt Standard Time"
    },
    {
      "value": "Europe/Chisinau",
      "label": "(UTC+02:00) Chisinau",
      "id": "E. Europe Standard Time"
    },
    {
      "value": "Europe/Tiraspol",
      "label": "(UTC+02:00) Chisinau",
      "id": "E. Europe Standard Time"
    },
    {
      "value": "Asia/Hebron",
      "label": "(UTC+02:00) Gaza, Hebron",
      "id": "West Bank Standard Time"
    },
    {
      "value": "Asia/Gaza",
      "label": "(UTC+02:00) Gaza, Hebron",
      "id": "West Bank Standard Time"
    },
    {
      "value": "Africa/Johannesburg",
      "label": "(UTC+02:00) Harare, Pretoria",
      "id": "South Africa Standard Time"
    },
    {
      "value": "Africa/Bujumbura",
      "label": "(UTC+02:00) Harare, Pretoria",
      "id": "South Africa Standard Time"
    },
    {
      "value": "Africa/Gaborone",
      "label": "(UTC+02:00) Harare, Pretoria",
      "id": "South Africa Standard Time"
    },
    {
      "value": "Africa/Lubumbashi",
      "label": "(UTC+02:00) Harare, Pretoria",
      "id": "South Africa Standard Time"
    },
    {
      "value": "Africa/Maseru",
      "label": "(UTC+02:00) Harare, Pretoria",
      "id": "South Africa Standard Time"
    },
    {
      "value": "Africa/Blantyre",
      "label": "(UTC+02:00) Harare, Pretoria",
      "id": "South Africa Standard Time"
    },
    {
      "value": "Africa/Maputo",
      "label": "(UTC+02:00) Harare, Pretoria",
      "id": "South Africa Standard Time"
    },
    {
      "value": "Africa/Kigali",
      "label": "(UTC+02:00) Harare, Pretoria",
      "id": "South Africa Standard Time"
    },
    {
      "value": "Africa/Mbabane",
      "label": "(UTC+02:00) Harare, Pretoria",
      "id": "South Africa Standard Time"
    },
    {
      "value": "Africa/Lusaka",
      "label": "(UTC+02:00) Harare, Pretoria",
      "id": "South Africa Standard Time"
    },
    {
      "value": "Africa/Harare",
      "label": "(UTC+02:00) Harare, Pretoria",
      "id": "South Africa Standard Time"
    },
    {
      "value": "Etc/GMT-2",
      "label": "(UTC+02:00) Harare, Pretoria",
      "id": "South Africa Standard Time"
    },
    {
      "value": "Europe/Kiev",
      "label": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
      "id": "FLE Standard Time"
    },
    {
      "value": "Europe/Mariehamn",
      "label": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
      "id": "FLE Standard Time"
    },
    {
      "value": "Europe/Sofia",
      "label": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
      "id": "FLE Standard Time"
    },
    {
      "value": "Europe/Tallinn",
      "label": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
      "id": "FLE Standard Time"
    },
    {
      "value": "Europe/Helsinki",
      "label": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
      "id": "FLE Standard Time"
    },
    {
      "value": "Europe/Vilnius",
      "label": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
      "id": "FLE Standard Time"
    },
    {
      "value": "Europe/Riga",
      "label": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
      "id": "FLE Standard Time"
    },
    {
      "value": "Europe/Kyiv",
      "label": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
      "id": "FLE Standard Time"
    },
    {
      "value": "Europe/Zaporozhye",
      "label": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
      "id": "FLE Standard Time"
    },
    {
      "value": "Europe/Uzhgorod",
      "label": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
      "id": "FLE Standard Time"
    },
    {
      "value": "Asia/Jerusalem",
      "label": "(UTC+02:00) Jerusalem",
      "id": "Israel Standard Time"
    },
    {
      "value": "Asia/Tel_Aviv",
      "label": "(UTC+02:00) Jerusalem",
      "id": "Israel Standard Time"
    },
    {
      "value": "Israel",
      "label": "(UTC+02:00) Jerusalem",
      "id": "Israel Standard Time"
    },
    {
      "value": "Africa/Juba",
      "label": "(UTC+02:00) Juba",
      "id": "South Sudan Standard Time"
    },
    {
      "value": "Europe/Kaliningrad",
      "label": "(UTC+02:00) Kaliningrad",
      "id": "Kaliningrad Standard Time"
    },
    {
      "value": "Africa/Khartoum",
      "label": "(UTC+02:00) Khartoum",
      "id": "Sudan Standard Time"
    },
    {
      "value": "Africa/Tripoli",
      "label": "(UTC+02:00) Tripoli",
      "id": "Libya Standard Time"
    },
    {
      "value": "Libya",
      "label": "(UTC+02:00) Tripoli",
      "id": "Libya Standard Time"
    },
    {
      "value": "Africa/Windhoek",
      "label": "(UTC+02:00) Windhoek",
      "id": "Namibia Standard Time"
    },
    {
      "value": "Asia/Amman",
      "label": "(UTC+03:00) Amman",
      "id": "Jordan Standard Time"
    },
    {
      "value": "Asia/Baghdad",
      "label": "(UTC+03:00) Baghdad",
      "id": "Arabic Standard Time"
    },
    {
      "value": "Asia/Damascus",
      "label": "(UTC+03:00) Damascus",
      "id": "Syria Standard Time"
    },
    {
      "value": "Europe/Istanbul",
      "label": "(UTC+03:00) Istanbul",
      "id": "Turkey Standard Time"
    },
    {
      "value": "Asia/Istanbul",
      "label": "(UTC+03:00) Istanbul",
      "id": "Turkey Standard Time"
    },
    {
      "value": "Turkey",
      "label": "(UTC+03:00) Istanbul",
      "id": "Turkey Standard Time"
    },
    {
      "value": "Asia/Riyadh",
      "label": "(UTC+03:00) Kuwait, Riyadh",
      "id": "Arab Standard Time"
    },
    {
      "value": "Asia/Bahrain",
      "label": "(UTC+03:00) Kuwait, Riyadh",
      "id": "Arab Standard Time"
    },
    {
      "value": "Asia/Kuwait",
      "label": "(UTC+03:00) Kuwait, Riyadh",
      "id": "Arab Standard Time"
    },
    {
      "value": "Asia/Qatar",
      "label": "(UTC+03:00) Kuwait, Riyadh",
      "id": "Arab Standard Time"
    },
    {
      "value": "Asia/Aden",
      "label": "(UTC+03:00) Kuwait, Riyadh",
      "id": "Arab Standard Time"
    },
    {
      "value": "Europe/Minsk",
      "label": "(UTC+03:00) Minsk",
      "id": "Belarus Standard Time"
    },
    {
      "value": "Europe/Moscow",
      "label": "(UTC+03:00) Moscow, St. Petersburg",
      "id": "Russian Standard Time"
    },
    {
      "value": "Europe/Kirov",
      "label": "(UTC+03:00) Moscow, St. Petersburg",
      "id": "Russian Standard Time"
    },
    {
      "value": "Europe/Simferopol",
      "label": "(UTC+03:00) Moscow, St. Petersburg",
      "id": "Russian Standard Time"
    },
    {
      "value": "W-SU",
      "label": "(UTC+03:00) Moscow, St. Petersburg",
      "id": "Russian Standard Time"
    },
    {
      "value": "Africa/Nairobi",
      "label": "(UTC+03:00) Nairobi",
      "id": "E. Africa Standard Time"
    },
    {
      "value": "Antarctica/Syowa",
      "label": "(UTC+03:00) Nairobi",
      "id": "E. Africa Standard Time"
    },
    {
      "value": "Africa/Djibouti",
      "label": "(UTC+03:00) Nairobi",
      "id": "E. Africa Standard Time"
    },
    {
      "value": "Africa/Asmera",
      "label": "(UTC+03:00) Nairobi",
      "id": "E. Africa Standard Time"
    },
    {
      "value": "Africa/Addis_Ababa",
      "label": "(UTC+03:00) Nairobi",
      "id": "E. Africa Standard Time"
    },
    {
      "value": "Indian/Comoro",
      "label": "(UTC+03:00) Nairobi",
      "id": "E. Africa Standard Time"
    },
    {
      "value": "Indian/Antananarivo",
      "label": "(UTC+03:00) Nairobi",
      "id": "E. Africa Standard Time"
    },
    {
      "value": "Africa/Mogadishu",
      "label": "(UTC+03:00) Nairobi",
      "id": "E. Africa Standard Time"
    },
    {
      "value": "Africa/Dar_es_Salaam",
      "label": "(UTC+03:00) Nairobi",
      "id": "E. Africa Standard Time"
    },
    {
      "value": "Africa/Kampala",
      "label": "(UTC+03:00) Nairobi",
      "id": "E. Africa Standard Time"
    },
    {
      "value": "Indian/Mayotte",
      "label": "(UTC+03:00) Nairobi",
      "id": "E. Africa Standard Time"
    },
    {
      "value": "Etc/GMT-3",
      "label": "(UTC+03:00) Nairobi",
      "id": "E. Africa Standard Time"
    },
    {
      "value": "Africa/Asmara",
      "label": "(UTC+03:00) Nairobi",
      "id": "E. Africa Standard Time"
    },
    {
      "value": "Europe/Volgograd",
      "label": "(UTC+03:00) Volgograd",
      "id": "Volgograd Standard Time"
    },
    {
      "value": "Asia/Tehran",
      "label": "(UTC+03:30) Tehran",
      "id": "Iran Standard Time"
    },
    {
      "value": "Iran",
      "label": "(UTC+03:30) Tehran",
      "id": "Iran Standard Time"
    },
    {
      "value": "Asia/Dubai",
      "label": "(UTC+04:00) Abu Dhabi, Muscat",
      "id": "Arabian Standard Time"
    },
    {
      "value": "Asia/Muscat",
      "label": "(UTC+04:00) Abu Dhabi, Muscat",
      "id": "Arabian Standard Time"
    },
    {
      "value": "Etc/GMT-4",
      "label": "(UTC+04:00) Abu Dhabi, Muscat",
      "id": "Arabian Standard Time"
    },
    {
      "value": "Europe/Astrakhan",
      "label": "(UTC+04:00) Astrakhan, Ulyanovsk",
      "id": "Astrakhan Standard Time"
    },
    {
      "value": "Europe/Ulyanovsk",
      "label": "(UTC+04:00) Astrakhan, Ulyanovsk",
      "id": "Astrakhan Standard Time"
    },
    {
      "value": "Asia/Baku",
      "label": "(UTC+04:00) Baku",
      "id": "Azerbaijan Standard Time"
    },
    {
      "value": "Europe/Samara",
      "label": "(UTC+04:00) Izhevsk, Samara",
      "id": "Russia Time Zone 3"
    },
    {
      "value": "Indian/Mauritius",
      "label": "(UTC+04:00) Port Louis",
      "id": "Mauritius Standard Time"
    },
    {
      "value": "Indian/Reunion",
      "label": "(UTC+04:00) Port Louis",
      "id": "Mauritius Standard Time"
    },
    {
      "value": "Indian/Mahe",
      "label": "(UTC+04:00) Port Louis",
      "id": "Mauritius Standard Time"
    },
    {
      "value": "Europe/Saratov",
      "label": "(UTC+04:00) Saratov",
      "id": "Saratov Standard Time"
    },
    {
      "value": "Asia/Tbilisi",
      "label": "(UTC+04:00) Tbilisi",
      "id": "Georgian Standard Time"
    },
    {
      "value": "Asia/Yerevan",
      "label": "(UTC+04:00) Yerevan",
      "id": "Caucasus Standard Time"
    },
    {
      "value": "Asia/Kabul",
      "label": "(UTC+04:30) Kabul",
      "id": "Afghanistan Standard Time"
    },
    {
      "value": "Asia/Tashkent",
      "label": "(UTC+05:00) Ashgabat, Tashkent",
      "id": "West Asia Standard Time"
    },
    {
      "value": "Antarctica/Mawson",
      "label": "(UTC+05:00) Ashgabat, Tashkent",
      "id": "West Asia Standard Time"
    },
    {
      "value": "Asia/Oral",
      "label": "(UTC+05:00) Ashgabat, Tashkent",
      "id": "West Asia Standard Time"
    },
    {
      "value": "Asia/Almaty",
      "label": "(UTC+05:00) Ashgabat, Tashkent",
      "id": "West Asia Standard Time"
    },
    {
      "value": "Asia/Aqtau",
      "label": "(UTC+05:00) Ashgabat, Tashkent",
      "id": "West Asia Standard Time"
    },
    {
      "value": "Asia/Aqtobe",
      "label": "(UTC+05:00) Ashgabat, Tashkent",
      "id": "West Asia Standard Time"
    },
    {
      "value": "Asia/Atyrau",
      "label": "(UTC+05:00) Ashgabat, Tashkent",
      "id": "West Asia Standard Time"
    },
    {
      "value": "Asia/Qostanay",
      "label": "(UTC+05:00) Ashgabat, Tashkent",
      "id": "West Asia Standard Time"
    },
    {
      "value": "Indian/Maldives",
      "label": "(UTC+05:00) Ashgabat, Tashkent",
      "id": "West Asia Standard Time"
    },
    {
      "value": "Indian/Kerguelen",
      "label": "(UTC+05:00) Ashgabat, Tashkent",
      "id": "West Asia Standard Time"
    },
    {
      "value": "Asia/Dushanbe",
      "label": "(UTC+05:00) Ashgabat, Tashkent",
      "id": "West Asia Standard Time"
    },
    {
      "value": "Asia/Ashgabat",
      "label": "(UTC+05:00) Ashgabat, Tashkent",
      "id": "West Asia Standard Time"
    },
    {
      "value": "Asia/Samarkand",
      "label": "(UTC+05:00) Ashgabat, Tashkent",
      "id": "West Asia Standard Time"
    },
    {
      "value": "Etc/GMT-5",
      "label": "(UTC+05:00) Ashgabat, Tashkent",
      "id": "West Asia Standard Time"
    },
    {
      "value": "Asia/Ashkhabad",
      "label": "(UTC+05:00) Ashgabat, Tashkent",
      "id": "West Asia Standard Time"
    },
    {
      "value": "Asia/Qyzylorda",
      "label": "(UTC+05:00) Astana",
      "id": "Qyzylorda Standard Time"
    },
    {
      "value": "Asia/Yekaterinburg",
      "label": "(UTC+05:00) Ekaterinburg",
      "id": "Ekaterinburg Standard Time"
    },
    {
      "value": "Asia/Karachi",
      "label": "(UTC+05:00) Islamabad, Karachi",
      "id": "Pakistan Standard Time"
    },
    {
      "value": "Asia/Calcutta",
      "label": "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
      "id": "India Standard Time"
    },
    {
      "value": "Asia/Kolkata",
      "label": "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
      "id": "India Standard Time"
    },
    {
      "value": "Asia/Colombo",
      "label": "(UTC+05:30) Sri Jayawardenepura",
      "id": "Sri Lanka Standard Time"
    },
    {
      "value": "Asia/Katmandu",
      "label": "(UTC+05:45) Kathmandu",
      "id": "Nepal Standard Time"
    },
    {
      "value": "Asia/Kathmandu",
      "label": "(UTC+05:45) Kathmandu",
      "id": "Nepal Standard Time"
    },
    {
      "value": "Asia/Bishkek",
      "label": "(UTC+06:00) Bishkek",
      "id": "Central Asia Standard Time"
    },
    {
      "value": "Antarctica/Vostok",
      "label": "(UTC+06:00) Bishkek",
      "id": "Central Asia Standard Time"
    },
    {
      "value": "Asia/Urumqi",
      "label": "(UTC+06:00) Bishkek",
      "id": "Central Asia Standard Time"
    },
    {
      "value": "Indian/Chagos",
      "label": "(UTC+06:00) Bishkek",
      "id": "Central Asia Standard Time"
    },
    {
      "value": "Etc/GMT-6",
      "label": "(UTC+06:00) Bishkek",
      "id": "Central Asia Standard Time"
    },
    {
      "value": "Asia/Kashgar",
      "label": "(UTC+06:00) Bishkek",
      "id": "Central Asia Standard Time"
    },
    {
      "value": "Asia/Dhaka",
      "label": "(UTC+06:00) Dhaka",
      "id": "Bangladesh Standard Time"
    },
    {
      "value": "Asia/Thimphu",
      "label": "(UTC+06:00) Dhaka",
      "id": "Bangladesh Standard Time"
    },
    {
      "value": "Asia/Dacca",
      "label": "(UTC+06:00) Dhaka",
      "id": "Bangladesh Standard Time"
    },
    {
      "value": "Asia/Thimbu",
      "label": "(UTC+06:00) Dhaka",
      "id": "Bangladesh Standard Time"
    },
    {
      "value": "Asia/Omsk",
      "label": "(UTC+06:00) Omsk",
      "id": "Omsk Standard Time"
    },
    {
      "value": "Asia/Rangoon",
      "label": "(UTC+06:30) Yangon (Rangoon)",
      "id": "Myanmar Standard Time"
    },
    {
      "value": "Indian/Cocos",
      "label": "(UTC+06:30) Yangon (Rangoon)",
      "id": "Myanmar Standard Time"
    },
    {
      "value": "Asia/Yangon",
      "label": "(UTC+06:30) Yangon (Rangoon)",
      "id": "Myanmar Standard Time"
    },
    {
      "value": "Asia/Bangkok",
      "label": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
      "id": "SE Asia Standard Time"
    },
    {
      "value": "Antarctica/Davis",
      "label": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
      "id": "SE Asia Standard Time"
    },
    {
      "value": "Indian/Christmas",
      "label": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
      "id": "SE Asia Standard Time"
    },
    {
      "value": "Asia/Jakarta",
      "label": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
      "id": "SE Asia Standard Time"
    },
    {
      "value": "Asia/Pontianak",
      "label": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
      "id": "SE Asia Standard Time"
    },
    {
      "value": "Asia/Phnom_Penh",
      "label": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
      "id": "SE Asia Standard Time"
    },
    {
      "value": "Asia/Vientiane",
      "label": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
      "id": "SE Asia Standard Time"
    },
    {
      "value": "Asia/Saigon",
      "label": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
      "id": "SE Asia Standard Time"
    },
    {
      "value": "Etc/GMT-7",
      "label": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
      "id": "SE Asia Standard Time"
    },
    {
      "value": "Asia/Ho_Chi_Minh",
      "label": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
      "id": "SE Asia Standard Time"
    },
    {
      "value": "Asia/Barnaul",
      "label": "(UTC+07:00) Barnaul, Gorno-Altaysk",
      "id": "Altai Standard Time"
    },
    {
      "value": "Asia/Hovd",
      "label": "(UTC+07:00) Hovd",
      "id": "W. Mongolia Standard Time"
    },
    {
      "value": "Asia/Krasnoyarsk",
      "label": "(UTC+07:00) Krasnoyarsk",
      "id": "North Asia Standard Time"
    },
    {
      "value": "Asia/Novokuznetsk",
      "label": "(UTC+07:00) Krasnoyarsk",
      "id": "North Asia Standard Time"
    },
    {
      "value": "Asia/Novosibirsk",
      "label": "(UTC+07:00) Novosibirsk",
      "id": "N. Central Asia Standard Time"
    },
    {
      "value": "Asia/Tomsk",
      "label": "(UTC+07:00) Tomsk",
      "id": "Tomsk Standard Time"
    },
    {
      "value": "Asia/Shanghai",
      "label": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
      "id": "China Standard Time"
    },
    {
      "value": "Asia/Hong_Kong",
      "label": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
      "id": "China Standard Time"
    },
    {
      "value": "Asia/Macau",
      "label": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
      "id": "China Standard Time"
    },
    {
      "value": "Hongkong",
      "label": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
      "id": "China Standard Time"
    },
    {
      "value": "Asia/Macao",
      "label": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
      "id": "China Standard Time"
    },
    {
      "value": "Asia/Chongqing",
      "label": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
      "id": "China Standard Time"
    },
    {
      "value": "Asia/Chungking",
      "label": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
      "id": "China Standard Time"
    },
    {
      "value": "Asia/Harbin",
      "label": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
      "id": "China Standard Time"
    },
    {
      "value": "PRC",
      "label": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
      "id": "China Standard Time"
    },
    {
      "value": "Asia/Irkutsk",
      "label": "(UTC+08:00) Irkutsk",
      "id": "North Asia East Standard Time"
    },
    {
      "value": "Asia/Singapore",
      "label": "(UTC+08:00) Kuala Lumpur, Singapore",
      "id": "Singapore Standard Time"
    },
    {
      "value": "Asia/Brunei",
      "label": "(UTC+08:00) Kuala Lumpur, Singapore",
      "id": "Singapore Standard Time"
    },
    {
      "value": "Asia/Makassar",
      "label": "(UTC+08:00) Kuala Lumpur, Singapore",
      "id": "Singapore Standard Time"
    },
    {
      "value": "Asia/Kuala_Lumpur",
      "label": "(UTC+08:00) Kuala Lumpur, Singapore",
      "id": "Singapore Standard Time"
    },
    {
      "value": "Asia/Kuching",
      "label": "(UTC+08:00) Kuala Lumpur, Singapore",
      "id": "Singapore Standard Time"
    },
    {
      "value": "Asia/Manila",
      "label": "(UTC+08:00) Kuala Lumpur, Singapore",
      "id": "Singapore Standard Time"
    },
    {
      "value": "Etc/GMT-8",
      "label": "(UTC+08:00) Kuala Lumpur, Singapore",
      "id": "Singapore Standard Time"
    },
    {
      "value": "Asia/Ujung_Pandang",
      "label": "(UTC+08:00) Kuala Lumpur, Singapore",
      "id": "Singapore Standard Time"
    },
    {
      "value": "Singapore",
      "label": "(UTC+08:00) Kuala Lumpur, Singapore",
      "id": "Singapore Standard Time"
    },
    {
      "value": "Australia/Perth",
      "label": "(UTC+08:00) Perth",
      "id": "W. Australia Standard Time"
    },
    {
      "value": "Australia/West",
      "label": "(UTC+08:00) Perth",
      "id": "W. Australia Standard Time"
    },
    {
      "value": "Asia/Taipei",
      "label": "(UTC+08:00) Taipei",
      "id": "Taipei Standard Time"
    },
    {
      "value": "ROC",
      "label": "(UTC+08:00) Taipei",
      "id": "Taipei Standard Time"
    },
    {
      "value": "Asia/Ulaanbaatar",
      "label": "(UTC+08:00) Ulaanbaatar",
      "id": "Ulaanbaatar Standard Time"
    },
    {
      "value": "Asia/Ulan_Bator",
      "label": "(UTC+08:00) Ulaanbaatar",
      "id": "Ulaanbaatar Standard Time"
    },
    {
      "value": "Asia/Choibalsan",
      "label": "(UTC+08:00) Ulaanbaatar",
      "id": "Ulaanbaatar Standard Time"
    },
    {
      "value": "Australia/Eucla",
      "label": "(UTC+08:45) Eucla",
      "id": "Aus Central W. Standard Time"
    },
    {
      "value": "Asia/Chita",
      "label": "(UTC+09:00) Chita",
      "id": "Transbaikal Standard Time"
    },
    {
      "value": "Asia/Tokyo",
      "label": "(UTC+09:00) Osaka, Sapporo, Tokyo",
      "id": "Tokyo Standard Time"
    },
    {
      "value": "Asia/Jayapura",
      "label": "(UTC+09:00) Osaka, Sapporo, Tokyo",
      "id": "Tokyo Standard Time"
    },
    {
      "value": "Pacific/Palau",
      "label": "(UTC+09:00) Osaka, Sapporo, Tokyo",
      "id": "Tokyo Standard Time"
    },
    {
      "value": "Asia/Dili",
      "label": "(UTC+09:00) Osaka, Sapporo, Tokyo",
      "id": "Tokyo Standard Time"
    },
    {
      "value": "Etc/GMT-9",
      "label": "(UTC+09:00) Osaka, Sapporo, Tokyo",
      "id": "Tokyo Standard Time"
    },
    {
      "value": "Japan",
      "label": "(UTC+09:00) Osaka, Sapporo, Tokyo",
      "id": "Tokyo Standard Time"
    },
    {
      "value": "Asia/Pyongyang",
      "label": "(UTC+09:00) Pyongyang",
      "id": "North Korea Standard Time"
    },
    {
      "value": "Asia/Seoul",
      "label": "(UTC+09:00) Seoul",
      "id": "Korea Standard Time"
    },
    {
      "value": "ROK",
      "label": "(UTC+09:00) Seoul",
      "id": "Korea Standard Time"
    },
    {
      "value": "Asia/Yakutsk",
      "label": "(UTC+09:00) Yakutsk",
      "id": "Yakutsk Standard Time"
    },
    {
      "value": "Asia/Khandyga",
      "label": "(UTC+09:00) Yakutsk",
      "id": "Yakutsk Standard Time"
    },
    {
      "value": "Australia/Adelaide",
      "label": "(UTC+09:30) Adelaide",
      "id": "Cen. Australia Standard Time"
    },
    {
      "value": "Australia/Broken_Hill",
      "label": "(UTC+09:30) Adelaide",
      "id": "Cen. Australia Standard Time"
    },
    {
      "value": "Australia/South",
      "label": "(UTC+09:30) Adelaide",
      "id": "Cen. Australia Standard Time"
    },
    {
      "value": "Australia/Yancowinna",
      "label": "(UTC+09:30) Adelaide",
      "id": "Cen. Australia Standard Time"
    },
    {
      "value": "Australia/Darwin",
      "label": "(UTC+09:30) Darwin",
      "id": "AUS Central Standard Time"
    },
    {
      "value": "Australia/North",
      "label": "(UTC+09:30) Darwin",
      "id": "AUS Central Standard Time"
    },
    {
      "value": "Australia/Brisbane",
      "label": "(UTC+10:00) Brisbane",
      "id": "E. Australia Standard Time"
    },
    {
      "value": "Australia/Lindeman",
      "label": "(UTC+10:00) Brisbane",
      "id": "E. Australia Standard Time"
    },
    {
      "value": "Australia/Queensland",
      "label": "(UTC+10:00) Brisbane",
      "id": "E. Australia Standard Time"
    },
    {
      "value": "Australia/Sydney",
      "label": "(UTC+10:00) Canberra, Melbourne, Sydney",
      "id": "AUS Eastern Standard Time"
    },
    {
      "value": "Australia/Melbourne",
      "label": "(UTC+10:00) Canberra, Melbourne, Sydney",
      "id": "AUS Eastern Standard Time"
    },
    {
      "value": "Australia/Victoria",
      "label": "(UTC+10:00) Canberra, Melbourne, Sydney",
      "id": "AUS Eastern Standard Time"
    },
    {
      "value": "Australia/ACT",
      "label": "(UTC+10:00) Canberra, Melbourne, Sydney",
      "id": "AUS Eastern Standard Time"
    },
    {
      "value": "Australia/Canberra",
      "label": "(UTC+10:00) Canberra, Melbourne, Sydney",
      "id": "AUS Eastern Standard Time"
    },
    {
      "value": "Australia/NSW",
      "label": "(UTC+10:00) Canberra, Melbourne, Sydney",
      "id": "AUS Eastern Standard Time"
    },
    {
      "value": "Pacific/Port_Moresby",
      "label": "(UTC+10:00) Guam, Port Moresby",
      "id": "West Pacific Standard Time"
    },
    {
      "value": "Antarctica/DumontDUrville",
      "label": "(UTC+10:00) Guam, Port Moresby",
      "id": "West Pacific Standard Time"
    },
    {
      "value": "Pacific/Truk",
      "label": "(UTC+10:00) Guam, Port Moresby",
      "id": "West Pacific Standard Time"
    },
    {
      "value": "Pacific/Guam",
      "label": "(UTC+10:00) Guam, Port Moresby",
      "id": "West Pacific Standard Time"
    },
    {
      "value": "Pacific/Saipan",
      "label": "(UTC+10:00) Guam, Port Moresby",
      "id": "West Pacific Standard Time"
    },
    {
      "value": "Etc/GMT-10",
      "label": "(UTC+10:00) Guam, Port Moresby",
      "id": "West Pacific Standard Time"
    },
    {
      "value": "Pacific/Chuuk",
      "label": "(UTC+10:00) Guam, Port Moresby",
      "id": "West Pacific Standard Time"
    },
    {
      "value": "Pacific/Yap",
      "label": "(UTC+10:00) Guam, Port Moresby",
      "id": "West Pacific Standard Time"
    },
    {
      "value": "Australia/Hobart",
      "label": "(UTC+10:00) Hobart",
      "id": "Tasmania Standard Time"
    },
    {
      "value": "Antarctica/Macquarie",
      "label": "(UTC+10:00) Hobart",
      "id": "Tasmania Standard Time"
    },
    {
      "value": "Australia/Tasmania",
      "label": "(UTC+10:00) Hobart",
      "id": "Tasmania Standard Time"
    },
    {
      "value": "Australia/Currie",
      "label": "(UTC+10:00) Hobart",
      "id": "Tasmania Standard Time"
    },
    {
      "value": "Asia/Vladivostok",
      "label": "(UTC+10:00) Vladivostok",
      "id": "Vladivostok Standard Time"
    },
    {
      "value": "Asia/Ust-Nera",
      "label": "(UTC+10:00) Vladivostok",
      "id": "Vladivostok Standard Time"
    },
    {
      "value": "Australia/Lord_Howe",
      "label": "(UTC+10:30) Lord Howe Island",
      "id": "Lord Howe Standard Time"
    },
    {
      "value": "Australia/LHI",
      "label": "(UTC+10:30) Lord Howe Island",
      "id": "Lord Howe Standard Time"
    },
    {
      "value": "Pacific/Bougainville",
      "label": "(UTC+11:00) Bougainville Island",
      "id": "Bougainville Standard Time"
    },
    {
      "value": "Asia/Srednekolymsk",
      "label": "(UTC+11:00) Chokurdakh",
      "id": "Russia Time Zone 10"
    },
    {
      "value": "Asia/Magadan",
      "label": "(UTC+11:00) Magadan",
      "id": "Magadan Standard Time"
    },
    {
      "value": "Pacific/Norfolk",
      "label": "(UTC+11:00) Norfolk Island",
      "id": "Norfolk Standard Time"
    },
    {
      "value": "Asia/Sakhalin",
      "label": "(UTC+11:00) Sakhalin",
      "id": "Sakhalin Standard Time"
    },
    {
      "value": "Pacific/Guadalcanal",
      "label": "(UTC+11:00) Solomon Is., New Caledonia",
      "id": "Central Pacific Standard Time"
    },
    {
      "value": "Antarctica/Casey",
      "label": "(UTC+11:00) Solomon Is., New Caledonia",
      "id": "Central Pacific Standard Time"
    },
    {
      "value": "Pacific/Ponape",
      "label": "(UTC+11:00) Solomon Is., New Caledonia",
      "id": "Central Pacific Standard Time"
    },
    {
      "value": "Pacific/Kosrae",
      "label": "(UTC+11:00) Solomon Is., New Caledonia",
      "id": "Central Pacific Standard Time"
    },
    {
      "value": "Pacific/Noumea",
      "label": "(UTC+11:00) Solomon Is., New Caledonia",
      "id": "Central Pacific Standard Time"
    },
    {
      "value": "Pacific/Efate",
      "label": "(UTC+11:00) Solomon Is., New Caledonia",
      "id": "Central Pacific Standard Time"
    },
    {
      "value": "Etc/GMT-11",
      "label": "(UTC+11:00) Solomon Is., New Caledonia",
      "id": "Central Pacific Standard Time"
    },
    {
      "value": "Pacific/Pohnpei",
      "label": "(UTC+11:00) Solomon Is., New Caledonia",
      "id": "Central Pacific Standard Time"
    },
    {
      "value": "Asia/Kamchatka",
      "label": "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky",
      "id": "Russia Time Zone 11"
    },
    {
      "value": "Asia/Anadyr",
      "label": "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky",
      "id": "Russia Time Zone 11"
    },
    {
      "value": "Pacific/Auckland",
      "label": "(UTC+12:00) Auckland, Wellington",
      "id": "New Zealand Standard Time"
    },
    {
      "value": "Antarctica/McMurdo",
      "label": "(UTC+12:00) Auckland, Wellington",
      "id": "New Zealand Standard Time"
    },
    {
      "value": "Antarctica/South_Pole",
      "label": "(UTC+12:00) Auckland, Wellington",
      "id": "New Zealand Standard Time"
    },
    {
      "value": "NZ",
      "label": "(UTC+12:00) Auckland, Wellington",
      "id": "New Zealand Standard Time"
    },
    {
      "value": "Etc/GMT-12",
      "label": "(UTC+12:00) Coordinated Universal Time+12",
      "id": "UTC+12"
    },
    {
      "value": "Pacific/Tarawa",
      "label": "(UTC+12:00) Coordinated Universal Time+12",
      "id": "UTC+12"
    },
    {
      "value": "Pacific/Majuro",
      "label": "(UTC+12:00) Coordinated Universal Time+12",
      "id": "UTC+12"
    },
    {
      "value": "Pacific/Kwajalein",
      "label": "(UTC+12:00) Coordinated Universal Time+12",
      "id": "UTC+12"
    },
    {
      "value": "Pacific/Nauru",
      "label": "(UTC+12:00) Coordinated Universal Time+12",
      "id": "UTC+12"
    },
    {
      "value": "Pacific/Funafuti",
      "label": "(UTC+12:00) Coordinated Universal Time+12",
      "id": "UTC+12"
    },
    {
      "value": "Pacific/Wake",
      "label": "(UTC+12:00) Coordinated Universal Time+12",
      "id": "UTC+12"
    },
    {
      "value": "Pacific/Wallis",
      "label": "(UTC+12:00) Coordinated Universal Time+12",
      "id": "UTC+12"
    },
    {
      "value": "Kwajalein",
      "label": "(UTC+12:00) Coordinated Universal Time+12",
      "id": "UTC+12"
    },
    {
      "value": "Pacific/Fiji",
      "label": "(UTC+12:00) Fiji",
      "id": "Fiji Standard Time"
    },
    {
      "value": "Pacific/Chatham",
      "label": "(UTC+12:45) Chatham Islands",
      "id": "Chatham Islands Standard Time"
    },
    {
      "value": "NZ-CHAT",
      "label": "(UTC+12:45) Chatham Islands",
      "id": "Chatham Islands Standard Time"
    },
    {
      "value": "Etc/GMT-13",
      "label": "(UTC+13:00) Coordinated Universal Time+13",
      "id": "UTC+13"
    },
    {
      "value": "Pacific/Enderbury",
      "label": "(UTC+13:00) Coordinated Universal Time+13",
      "id": "UTC+13"
    },
    {
      "value": "Pacific/Fakaofo",
      "label": "(UTC+13:00) Coordinated Universal Time+13",
      "id": "UTC+13"
    },
    {
      "value": "Pacific/Kanton",
      "label": "(UTC+13:00) Coordinated Universal Time+13",
      "id": "UTC+13"
    },
    {
      "value": "Pacific/Tongatapu",
      "label": "(UTC+13:00) Nuku'alofa",
      "id": "Tonga Standard Time"
    },
    {
      "value": "Pacific/Apia",
      "label": "(UTC+13:00) Samoa",
      "id": "Samoa Standard Time"
    },
    {
      "value": "Pacific/Kiritimati",
      "label": "(UTC+14:00) Kiritimati Island",
      "id": "Line Islands Standard Time"
    },
    {
      "value": "Etc/GMT-14",
      "label": "(UTC+14:00) Kiritimati Island",
      "id": "Line Islands Standard Time"
    }
  ],
  "winTimezones": [
    {
      "value": "Atlantic/Azores",
      "label": "(UTC-01:00) Azores",
      "id": "Azores Standard Time"
    },
    {
      "value": "Atlantic/Cape_Verde",
      "label": "(UTC-01:00) Cabo Verde Is.",
      "id": "Cape Verde Standard Time"
    },
    {
      "value": "Etc/GMT+2",
      "label": "(UTC-02:00) Coordinated Universal Time-02",
      "id": "UTC-02"
    },
    {
      "value": "America/Godthab",
      "label": "(UTC-02:00) Greenland",
      "id": "Greenland Standard Time"
    },
    {
      "value": "America/Araguaina",
      "label": "(UTC-03:00) Araguaina",
      "id": "Tocantins Standard Time"
    },
    {
      "value": "America/Asuncion",
      "label": "(UTC-03:00) Asuncion",
      "id": "Paraguay Standard Time"
    },
    {
      "value": "America/Sao_Paulo",
      "label": "(UTC-03:00) Brasilia",
      "id": "E. South America Standard Time"
    },
    {
      "value": "America/Cayenne",
      "label": "(UTC-03:00) Cayenne, Fortaleza",
      "id": "SA Eastern Standard Time"
    },
    {
      "value": "America/Buenos_Aires",
      "label": "(UTC-03:00) City of Buenos Aires",
      "id": "Argentina Standard Time"
    },
    {
      "value": "America/Montevideo",
      "label": "(UTC-03:00) Montevideo",
      "id": "Montevideo Standard Time"
    },
    {
      "value": "America/Punta_Arenas",
      "label": "(UTC-03:00) Punta Arenas",
      "id": "Magallanes Standard Time"
    },
    {
      "value": "America/Miquelon",
      "label": "(UTC-03:00) Saint Pierre and Miquelon",
      "id": "Saint Pierre Standard Time"
    },
    {
      "value": "America/Bahia",
      "label": "(UTC-03:00) Salvador",
      "id": "Bahia Standard Time"
    },
    {
      "value": "America/St_Johns",
      "label": "(UTC-03:30) Newfoundland",
      "id": "Newfoundland Standard Time"
    },
    {
      "value": "America/Halifax",
      "label": "(UTC-04:00) Atlantic Time (Canada)",
      "id": "Atlantic Standard Time"
    },
    {
      "value": "America/Caracas",
      "label": "(UTC-04:00) Caracas",
      "id": "Venezuela Standard Time"
    },
    {
      "value": "America/Cuiaba",
      "label": "(UTC-04:00) Cuiaba",
      "id": "Central Brazilian Standard Time"
    },
    {
      "value": "America/La_Paz",
      "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
      "id": "SA Western Standard Time"
    },
    {
      "value": "America/Santiago",
      "label": "(UTC-04:00) Santiago",
      "id": "Pacific SA Standard Time"
    },
    {
      "value": "America/Bogota",
      "label": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
      "id": "SA Pacific Standard Time"
    },
    {
      "value": "America/Cancun",
      "label": "(UTC-05:00) Chetumal",
      "id": "Eastern Standard Time (Mexico)"
    },
    {
      "value": "America/New_York",
      "label": "(UTC-05:00) Eastern Time (US & Canada)",
      "id": "Eastern Standard Time"
    },
    {
      "value": "America/Port-au-Prince",
      "label": "(UTC-05:00) Haiti",
      "id": "Haiti Standard Time"
    },
    {
      "value": "America/Havana",
      "label": "(UTC-05:00) Havana",
      "id": "Cuba Standard Time"
    },
    {
      "value": "America/Indianapolis",
      "label": "(UTC-05:00) Indiana (East)",
      "id": "US Eastern Standard Time"
    },
    {
      "value": "America/Grand_Turk",
      "label": "(UTC-05:00) Turks and Caicos",
      "id": "Turks And Caicos Standard Time"
    },
    {
      "value": "America/Guatemala",
      "label": "(UTC-06:00) Central America",
      "id": "Central America Standard Time"
    },
    {
      "value": "America/Chicago",
      "label": "(UTC-06:00) Central Time (US & Canada)",
      "id": "Central Standard Time"
    },
    {
      "value": "Pacific/Easter",
      "label": "(UTC-06:00) Easter Island",
      "id": "Easter Island Standard Time"
    },
    {
      "value": "America/Mexico_City",
      "label": "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
      "id": "Central Standard Time (Mexico)"
    },
    {
      "value": "America/Regina",
      "label": "(UTC-06:00) Saskatchewan",
      "id": "Canada Central Standard Time"
    },
    {
      "value": "America/Phoenix",
      "label": "(UTC-07:00) Arizona",
      "id": "US Mountain Standard Time"
    },
    {
      "value": "America/Mazatlan",
      "label": "(UTC-07:00) La Paz, Mazatlan",
      "id": "Mountain Standard Time (Mexico)"
    },
    {
      "value": "America/Denver",
      "label": "(UTC-07:00) Mountain Time (US & Canada)",
      "id": "Mountain Standard Time"
    },
    {
      "value": "America/Whitehorse",
      "label": "(UTC-07:00) Yukon",
      "id": "Yukon Standard Time"
    },
    {
      "value": "America/Tijuana",
      "label": "(UTC-08:00) Baja California",
      "id": "Pacific Standard Time (Mexico)"
    },
    {
      "value": "Etc/GMT+8",
      "label": "(UTC-08:00) Coordinated Universal Time-08",
      "id": "UTC-08"
    },
    {
      "value": "America/Los_Angeles",
      "label": "(UTC-08:00) Pacific Time (US & Canada)",
      "id": "Pacific Standard Time"
    },
    {
      "value": "America/Anchorage",
      "label": "(UTC-09:00) Alaska",
      "id": "Alaskan Standard Time"
    },
    {
      "value": "Etc/GMT+9",
      "label": "(UTC-09:00) Coordinated Universal Time-09",
      "id": "UTC-09"
    },
    {
      "value": "Pacific/Marquesas",
      "label": "(UTC-09:30) Marquesas Islands",
      "id": "Marquesas Standard Time"
    },
    {
      "value": "America/Adak",
      "label": "(UTC-10:00) Aleutian Islands",
      "id": "Aleutian Standard Time"
    },
    {
      "value": "Pacific/Honolulu",
      "label": "(UTC-10:00) Hawaii",
      "id": "Hawaiian Standard Time"
    },
    {
      "value": "Etc/GMT+11",
      "label": "(UTC-11:00) Coordinated Universal Time-11",
      "id": "UTC-11"
    },
    {
      "value": "Etc/GMT+12",
      "label": "(UTC-12:00) International Date Line West",
      "id": "Dateline Standard Time"
    },
    {
      "value": "Etc/UTC",
      "label": "(UTC) Coordinated Universal Time",
      "id": "UTC"
    },
    {
      "value": "Europe/London",
      "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
      "id": "GMT Standard Time"
    },
    {
      "value": "Atlantic/Reykjavik",
      "label": "(UTC+00:00) Monrovia, Reykjavik",
      "id": "Greenwich Standard Time"
    },
    {
      "value": "Africa/Sao_Tome",
      "label": "(UTC+00:00) Sao Tome",
      "id": "Sao Tome Standard Time"
    },
    {
      "value": "Europe/Berlin",
      "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      "id": "W. Europe Standard Time"
    },
    {
      "value": "Europe/Budapest",
      "label": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
      "id": "Central Europe Standard Time"
    },
    {
      "value": "Europe/Paris",
      "label": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
      "id": "Romance Standard Time"
    },
    {
      "value": "Africa/Casablanca",
      "label": "(UTC+01:00) Casablanca",
      "id": "Morocco Standard Time"
    },
    {
      "value": "Europe/Warsaw",
      "label": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
      "id": "Central European Standard Time"
    },
    {
      "value": "Africa/Lagos",
      "label": "(UTC+01:00) West Central Africa",
      "id": "W. Central Africa Standard Time"
    },
    {
      "value": "Europe/Bucharest",
      "label": "(UTC+02:00) Athens, Bucharest",
      "id": "GTB Standard Time"
    },
    {
      "value": "Asia/Beirut",
      "label": "(UTC+02:00) Beirut",
      "id": "Middle East Standard Time"
    },
    {
      "value": "Africa/Cairo",
      "label": "(UTC+02:00) Cairo",
      "id": "Egypt Standard Time"
    },
    {
      "value": "Europe/Chisinau",
      "label": "(UTC+02:00) Chisinau",
      "id": "E. Europe Standard Time"
    },
    {
      "value": "Asia/Hebron",
      "label": "(UTC+02:00) Gaza, Hebron",
      "id": "West Bank Standard Time"
    },
    {
      "value": "Africa/Johannesburg",
      "label": "(UTC+02:00) Harare, Pretoria",
      "id": "South Africa Standard Time"
    },
    {
      "value": "Europe/Kiev",
      "label": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
      "id": "FLE Standard Time"
    },
    {
      "value": "Asia/Jerusalem",
      "label": "(UTC+02:00) Jerusalem",
      "id": "Israel Standard Time"
    },
    {
      "value": "Africa/Juba",
      "label": "(UTC+02:00) Juba",
      "id": "South Sudan Standard Time"
    },
    {
      "value": "Europe/Kaliningrad",
      "label": "(UTC+02:00) Kaliningrad",
      "id": "Kaliningrad Standard Time"
    },
    {
      "value": "Africa/Khartoum",
      "label": "(UTC+02:00) Khartoum",
      "id": "Sudan Standard Time"
    },
    {
      "value": "Africa/Tripoli",
      "label": "(UTC+02:00) Tripoli",
      "id": "Libya Standard Time"
    },
    {
      "value": "Africa/Windhoek",
      "label": "(UTC+02:00) Windhoek",
      "id": "Namibia Standard Time"
    },
    {
      "value": "Asia/Amman",
      "label": "(UTC+03:00) Amman",
      "id": "Jordan Standard Time"
    },
    {
      "value": "Asia/Baghdad",
      "label": "(UTC+03:00) Baghdad",
      "id": "Arabic Standard Time"
    },
    {
      "value": "Asia/Damascus",
      "label": "(UTC+03:00) Damascus",
      "id": "Syria Standard Time"
    },
    {
      "value": "Europe/Istanbul",
      "label": "(UTC+03:00) Istanbul",
      "id": "Turkey Standard Time"
    },
    {
      "value": "Asia/Riyadh",
      "label": "(UTC+03:00) Kuwait, Riyadh",
      "id": "Arab Standard Time"
    },
    {
      "value": "Europe/Minsk",
      "label": "(UTC+03:00) Minsk",
      "id": "Belarus Standard Time"
    },
    {
      "value": "Europe/Moscow",
      "label": "(UTC+03:00) Moscow, St. Petersburg",
      "id": "Russian Standard Time"
    },
    {
      "value": "Africa/Nairobi",
      "label": "(UTC+03:00) Nairobi",
      "id": "E. Africa Standard Time"
    },
    {
      "value": "Europe/Volgograd",
      "label": "(UTC+03:00) Volgograd",
      "id": "Volgograd Standard Time"
    },
    {
      "value": "Asia/Tehran",
      "label": "(UTC+03:30) Tehran",
      "id": "Iran Standard Time"
    },
    {
      "value": "Asia/Dubai",
      "label": "(UTC+04:00) Abu Dhabi, Muscat",
      "id": "Arabian Standard Time"
    },
    {
      "value": "Europe/Astrakhan",
      "label": "(UTC+04:00) Astrakhan, Ulyanovsk",
      "id": "Astrakhan Standard Time"
    },
    {
      "value": "Asia/Baku",
      "label": "(UTC+04:00) Baku",
      "id": "Azerbaijan Standard Time"
    },
    {
      "value": "Europe/Samara",
      "label": "(UTC+04:00) Izhevsk, Samara",
      "id": "Russia Time Zone 3"
    },
    {
      "value": "Indian/Mauritius",
      "label": "(UTC+04:00) Port Louis",
      "id": "Mauritius Standard Time"
    },
    {
      "value": "Europe/Saratov",
      "label": "(UTC+04:00) Saratov",
      "id": "Saratov Standard Time"
    },
    {
      "value": "Asia/Tbilisi",
      "label": "(UTC+04:00) Tbilisi",
      "id": "Georgian Standard Time"
    },
    {
      "value": "Asia/Yerevan",
      "label": "(UTC+04:00) Yerevan",
      "id": "Caucasus Standard Time"
    },
    {
      "value": "Asia/Kabul",
      "label": "(UTC+04:30) Kabul",
      "id": "Afghanistan Standard Time"
    },
    {
      "value": "Asia/Tashkent",
      "label": "(UTC+05:00) Ashgabat, Tashkent",
      "id": "West Asia Standard Time"
    },
    {
      "value": "Asia/Qyzylorda",
      "label": "(UTC+05:00) Astana",
      "id": "Qyzylorda Standard Time"
    },
    {
      "value": "Asia/Yekaterinburg",
      "label": "(UTC+05:00) Ekaterinburg",
      "id": "Ekaterinburg Standard Time"
    },
    {
      "value": "Asia/Karachi",
      "label": "(UTC+05:00) Islamabad, Karachi",
      "id": "Pakistan Standard Time"
    },
    {
      "value": "Asia/Calcutta",
      "label": "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
      "id": "India Standard Time"
    },
    {
      "value": "Asia/Colombo",
      "label": "(UTC+05:30) Sri Jayawardenepura",
      "id": "Sri Lanka Standard Time"
    },
    {
      "value": "Asia/Katmandu",
      "label": "(UTC+05:45) Kathmandu",
      "id": "Nepal Standard Time"
    },
    {
      "value": "Asia/Bishkek",
      "label": "(UTC+06:00) Bishkek",
      "id": "Central Asia Standard Time"
    },
    {
      "value": "Asia/Dhaka",
      "label": "(UTC+06:00) Dhaka",
      "id": "Bangladesh Standard Time"
    },
    {
      "value": "Asia/Omsk",
      "label": "(UTC+06:00) Omsk",
      "id": "Omsk Standard Time"
    },
    {
      "value": "Asia/Rangoon",
      "label": "(UTC+06:30) Yangon (Rangoon)",
      "id": "Myanmar Standard Time"
    },
    {
      "value": "Asia/Bangkok",
      "label": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
      "id": "SE Asia Standard Time"
    },
    {
      "value": "Asia/Barnaul",
      "label": "(UTC+07:00) Barnaul, Gorno-Altaysk",
      "id": "Altai Standard Time"
    },
    {
      "value": "Asia/Hovd",
      "label": "(UTC+07:00) Hovd",
      "id": "W. Mongolia Standard Time"
    },
    {
      "value": "Asia/Krasnoyarsk",
      "label": "(UTC+07:00) Krasnoyarsk",
      "id": "North Asia Standard Time"
    },
    {
      "value": "Asia/Novosibirsk",
      "label": "(UTC+07:00) Novosibirsk",
      "id": "N. Central Asia Standard Time"
    },
    {
      "value": "Asia/Tomsk",
      "label": "(UTC+07:00) Tomsk",
      "id": "Tomsk Standard Time"
    },
    {
      "value": "Asia/Shanghai",
      "label": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
      "id": "China Standard Time"
    },
    {
      "value": "Asia/Irkutsk",
      "label": "(UTC+08:00) Irkutsk",
      "id": "North Asia East Standard Time"
    },
    {
      "value": "Asia/Singapore",
      "label": "(UTC+08:00) Kuala Lumpur, Singapore",
      "id": "Singapore Standard Time"
    },
    {
      "value": "Australia/Perth",
      "label": "(UTC+08:00) Perth",
      "id": "W. Australia Standard Time"
    },
    {
      "value": "Asia/Taipei",
      "label": "(UTC+08:00) Taipei",
      "id": "Taipei Standard Time"
    },
    {
      "value": "Asia/Ulaanbaatar",
      "label": "(UTC+08:00) Ulaanbaatar",
      "id": "Ulaanbaatar Standard Time"
    },
    {
      "value": "Australia/Eucla",
      "label": "(UTC+08:45) Eucla",
      "id": "Aus Central W. Standard Time"
    },
    {
      "value": "Asia/Chita",
      "label": "(UTC+09:00) Chita",
      "id": "Transbaikal Standard Time"
    },
    {
      "value": "Asia/Tokyo",
      "label": "(UTC+09:00) Osaka, Sapporo, Tokyo",
      "id": "Tokyo Standard Time"
    },
    {
      "value": "Asia/Pyongyang",
      "label": "(UTC+09:00) Pyongyang",
      "id": "North Korea Standard Time"
    },
    {
      "value": "Asia/Seoul",
      "label": "(UTC+09:00) Seoul",
      "id": "Korea Standard Time"
    },
    {
      "value": "Asia/Yakutsk",
      "label": "(UTC+09:00) Yakutsk",
      "id": "Yakutsk Standard Time"
    },
    {
      "value": "Australia/Adelaide",
      "label": "(UTC+09:30) Adelaide",
      "id": "Cen. Australia Standard Time"
    },
    {
      "value": "Australia/Darwin",
      "label": "(UTC+09:30) Darwin",
      "id": "AUS Central Standard Time"
    },
    {
      "value": "Australia/Brisbane",
      "label": "(UTC+10:00) Brisbane",
      "id": "E. Australia Standard Time"
    },
    {
      "value": "Australia/Sydney",
      "label": "(UTC+10:00) Canberra, Melbourne, Sydney",
      "id": "AUS Eastern Standard Time"
    },
    {
      "value": "Pacific/Port_Moresby",
      "label": "(UTC+10:00) Guam, Port Moresby",
      "id": "West Pacific Standard Time"
    },
    {
      "value": "Australia/Hobart",
      "label": "(UTC+10:00) Hobart",
      "id": "Tasmania Standard Time"
    },
    {
      "value": "Asia/Vladivostok",
      "label": "(UTC+10:00) Vladivostok",
      "id": "Vladivostok Standard Time"
    },
    {
      "value": "Australia/Lord_Howe",
      "label": "(UTC+10:30) Lord Howe Island",
      "id": "Lord Howe Standard Time"
    },
    {
      "value": "Pacific/Bougainville",
      "label": "(UTC+11:00) Bougainville Island",
      "id": "Bougainville Standard Time"
    },
    {
      "value": "Asia/Srednekolymsk",
      "label": "(UTC+11:00) Chokurdakh",
      "id": "Russia Time Zone 10"
    },
    {
      "value": "Asia/Magadan",
      "label": "(UTC+11:00) Magadan",
      "id": "Magadan Standard Time"
    },
    {
      "value": "Pacific/Norfolk",
      "label": "(UTC+11:00) Norfolk Island",
      "id": "Norfolk Standard Time"
    },
    {
      "value": "Asia/Sakhalin",
      "label": "(UTC+11:00) Sakhalin",
      "id": "Sakhalin Standard Time"
    },
    {
      "value": "Pacific/Guadalcanal",
      "label": "(UTC+11:00) Solomon Is., New Caledonia",
      "id": "Central Pacific Standard Time"
    },
    {
      "value": "Asia/Kamchatka",
      "label": "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky",
      "id": "Russia Time Zone 11"
    },
    {
      "value": "Pacific/Auckland",
      "label": "(UTC+12:00) Auckland, Wellington",
      "id": "New Zealand Standard Time"
    },
    {
      "value": "Etc/GMT-12",
      "label": "(UTC+12:00) Coordinated Universal Time+12",
      "id": "UTC+12"
    },
    {
      "value": "Pacific/Fiji",
      "label": "(UTC+12:00) Fiji",
      "id": "Fiji Standard Time"
    },
    {
      "value": "Pacific/Chatham",
      "label": "(UTC+12:45) Chatham Islands",
      "id": "Chatham Islands Standard Time"
    },
    {
      "value": "Etc/GMT-13",
      "label": "(UTC+13:00) Coordinated Universal Time+13",
      "id": "UTC+13"
    },
    {
      "value": "Pacific/Tongatapu",
      "label": "(UTC+13:00) Nuku'alofa",
      "id": "Tonga Standard Time"
    },
    {
      "value": "Pacific/Apia",
      "label": "(UTC+13:00) Samoa",
      "id": "Samoa Standard Time"
    },
    {
      "value": "Pacific/Kiritimati",
      "label": "(UTC+14:00) Kiritimati Island",
      "id": "Line Islands Standard Time"
    }
  ]
}